export default "<ng-template #loading>\n    <mat-spinner *ngIf=\"show\"></mat-spinner>\n</ng-template>";